<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout titlePage="Minha carteira">
    <Onboarding />
    <div
      v-if="walletSummary.loading || walletSummary.pending"
      class="has-text-centered"
    >
      <base-reload :isReload="false" :dark="true" label="" />
    </div>
    <WalletWithShopping
      v-else-if="
        walletSummary &&
        walletSummary.wallet &&
        walletSummary.wallet.settings &&
        walletSummary.wallet.settings.shopping
      "
    />
    <WalletWithoutShopping v-else />

    <div v-if="!this.logonToken.token_payload.cx_access">
      <RegisterNameAndCPFModalPix v-if="hasntCPFOwners" ref="CPFModalPix" />
      <RegisterPhone
        v-if="hasntPhoneWallet && !hasntCPFOwners"
        @open-modal-verification="openModalVerification"
      />
    </div>

    <VerificationPhone
      ref="validationPhone"
      :isRegisterNumber="true"
      :nextStep="'wallet'"
    />
  </layout>
</template>

<script>
import RegisterNameAndCPFModalPix from '@/components/Profile/RegisterNameAndCPFModalPix.vue'

import WalletWithoutShopping from '@/components/Wallet/WalletWithoutShopping.vue'
import WalletWithShopping from '@/components/Wallet/WalletWithShopping.vue'
import Onboarding from '@/components/Wallet/Onboarding.vue'
import layout from '@/layouts/Default.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'

import RegisterPhone from '@/components/Profile/Sms/RegisterPhoneModal.vue'
import VerificationPhone from '@/components/Profile/Sms/ValidationPhoneModal.vue'

export default {
  mixins: [loadingViewMixin, walletDataMixin],

  components: {
    RegisterNameAndCPFModalPix,
    WalletWithoutShopping,
    WalletWithShopping,
    Onboarding,
    layout,
    RegisterPhone,
    VerificationPhone,
  },

  metaInfo: {
    title: 'Minha Carteira',
  },

  data() {
    return {
      openModalRegistroPhone: false,
      app_env: process.env.VUE_APP_ENV,
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    hasntCPFOwners() {
      return (
        !this.walletSummary.loading &&
        this.walletSummary?.wallet &&
        !this.walletSummary?.owner_cpf
      )
    },

    hasntPhoneWallet() {
      return (
        !sessionStorage.getItem('registerPhoneAfter') &&
        !this.phoneWalletInfo.loading &&
        !this.phoneWalletInfo?.receiver_identifier
      )
    },
  },

  async mounted() {
    if (this.walletSummary.total_cashback && this.wedSiteInfo) {
      this.openModalNps(this.wedSiteInfo)
    }
  },

  methods: {
    isProductionNps() {
      let isProduction = ''
      this.app_env != 'production'
        ? (isProduction = 'shopping_teste')
        : (isProduction = 'shopping_producao')

      return isProduction
    },

    getDataWed(data) {
      const result = data.casamento_data.split('-')
      return result[0] + result[1]
    },

    openModalNps(data) {
      // START OF TEST ONLY FLAGS
      //window.wootric_survey_immediately = true //Overwrites sampling settings and forces the server to return true to all survey requests.
      //window.wootric_no_surveyed_cookie = true //Disables the cookie writing after a survey is taken effectively disabling any client side mechanisms to prevent multiple surveys from being rendered.
      // END OF TEST ONLY FLAGS
      const timestamp = new Date().getTime()
      const data_wedding = this.getDataWed(data)
      window.wootricSettings = {
        email: data.site_email, //TODO: Required to uniquely identify a user. Email is recommended but this can be any unique identifier.
        created_at: parseInt(timestamp / 1000), //TODO:replace it with date when your customer signed up
        account_token: 'NPS-92617a53', //TODO:replace it with your account token
        product_name: 'o Shopping Casar.com',
        properties: {
          tipo_usuario: 'noivo',
          data_casamento: data_wedding,
          plano: data.plano.plano,
          momento: this.isProductionNps(),
          eventos: '',
          ganhou_presentes: '1',
          status_ativacao: 'ativado',
        },
      }
      window.wootric('run')
    },

    openModalVerification(payload) {
      payload ? this.$refs.validationPhone.open(payload) : ''
    },
  },
}
</script>

<style lang="scss">
// #MazPhoneNumberInput {
//   input {
//     border-color: #ccc !important;
//   }

//   label {
//     color: #747474 !important;
//   }
// }

/* Firefox */
input[type='number'] {
  appearance: textfield !important;
}
</style>
